<template>
    <div
        v-if="this.playlistId"
        class="d-flex flex-row align-center youtube-playlist"
    >
        <div
            class="d-flex flex-row align-center youtube-inner"
            @click="() => redirectToPlaylist(this.videoId, this.playlistId)"
        >
            <img
                class="mr-2 white--text"
                width="40px"
                onload="SVGInject(this)"
                src="/images/_SVGs/play-circle-outline.svg"
            />
            <a href="javascript:void(0)">{{ $t("b2b.watch-tutorial") }}</a>
        </div>
    </div>
</template>

<script>
import mixinTutorials from "@mixins/b2b/tutorials.js";

export default {
    mixins: [mixinTutorials],
    props: {
        moduleId: {
            type: Number,
            required: true,
        },
    },
    mounted() {
        let authModules = this.$store.getters["auth/getState"].modules;
        let vi = authModules.find((e) => e.moduleId == this.moduleId);
        if (vi.youtubePlaylist) {
            this.playlistId = vi.youtubePlaylist;
            this.getFirstVideoFromPlaylist();
        }
    },
};
</script>

<style scoped>
.youtube-playlist {
    margin-bottom: 20px;
    max-width: 150px;
}

.youtube-inner {
    cursor: pointer;
}
</style>
